import axios from "../api";
import { CRYPTO_TOKEN_SECRET_KEY } from "../config";
import CryptoJS from "crypto-js";

const getAuthToken = () => {
    const decryptedData = CryptoJS.AES.decrypt(
        localStorage.getItem("token"),
        CRYPTO_TOKEN_SECRET_KEY
    ).toString(CryptoJS.enc.Utf8);
    return decryptedData;
};

export const verifyEmail = async(data) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`/api/auth/verify-email`, data)
            .then((response) => {
                resolve(response?.data);
            })
            .catch((error) => {
                reject(error);
            });
    })
}

export const login = async (data) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`/api/auth/login`, data)
            .then((response) => {
                resolve(response?.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const changePassword = async (data) => {
    const authToken = getAuthToken();
    const headers = {
        Authorization: `Bearer ${authToken}`,
    };
    return new Promise((resolve, reject) => {
        axios
            .post(`/api/auth/change-password`, data, {
                headers: headers,
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const changePasswordAuth = async (data) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`/api/auth/changePassword-Auth`, data)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const resetPassword = async (data) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`/api/auth/reset-password-email`, data)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const verifyOtp = async (otp, accessToken) => {
    const data = {
        otp: otp,
        token: accessToken,
    };
    return new Promise((resolve, reject) => {
        axios
            .post(`/api/auth/verify-otp`, data)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const resetNewPassword = async (data) => {
    return new Promise((resolve, reject) => {
        axios
            .put(`/api/auth/set-password`, data)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const resendOtp = async (data) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`/api/auth/resend-otp`, data)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getMasterUserProfileDetails = async () => {
    const authToken = getAuthToken();
    const headers = {
        Authorization: `Bearer ${authToken}`,
    };
    return new Promise((resolve, reject) => {
        axios
            .get(`/api/auth/get-user-profile`, {
                headers: headers,
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const enableTwoFactorAuth = async (data) => {
    return new Promise((resolve, reject) => {
        axios
            .put("/api/auth/enable-twofactor", data)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error.response.data);
            });
    });
};
